import * as React from 'react';

import StoryRootStore from './story.RootStore';
import ArticleContainer from '../../containers/article';
import ArticleNewsListContainer from '../../containers/articleNewsList';
import ShareLineContainer from '../../containers/shareLine';
import { pv } from '../../common/wastat';
// import CommentListContainer from '../../components/container/commentList';
import CommentWrapContainer from '../../containers/commentWrap';
import AdvertisingContainer from '../../containers/advertising';
import { DownloadButton } from '../../containers/deeplink';

interface IComponentProps {
  rootStore: StoryRootStore;
}

interface IComponentState {
  isVisibleAdAir: boolean;
  isVisibleAdRussia: boolean;
}

export default class Story extends React.Component<IComponentProps, IComponentState> {
  constructor(props) {
    super(props);
    this.state = {
      isVisibleAdAir: false,
      isVisibleAdRussia: false,
    };
  }

  public componentDidMount(): void {
    // componentDidMount只会在前端运行，不会在SSR中被运行。
    // const { rootStore: { advertisingStore: { config } } } = this.props;
    pv();
    // pvWithParams({
    //   bucket: config.article.bucket,
    // });
  }

  public render() {
    const Article = ArticleContainer();
    // const ArticleNewsList: any = ArticleNewsListContainer();
    const ShareLine = ShareLineContainer();
    const CommentWrap = CommentWrapContainer();
    const Advertising = AdvertisingContainer();
    const rootStore = this.props.rootStore;
    const { rootStore: { advertisingStore: { config, scriptSrc } } } = this.props;

    return (
      <>
        <div>
          <Advertising type="header" config={config} scriptSrc={scriptSrc} />
          <Article></Article>
          <ShareLine />
          <div style={{ marginTop: '8px' }}>
            {/* 底部广告 */}
            <Advertising type="footer" config={config} scriptSrc={scriptSrc} />
          </div>
          <ArticleNewsListContainer />
          <CommentWrap />
        </div>
        {
          rootStore.useRussia ? <DownloadButton text={'Читай в UC Browser'} /> : null
        }
      </>
    );
  }
}
